const DEFAULT_PROMPTS = [
  'What’s one of your secret talents?',
  'What\'s something you\'re looking forward to?',
  'If you could have one superpower for a day, what would it be and why?',
];

export {
  DEFAULT_PROMPTS,
};
